import { createDefaultSearchDatetimeRange } from "@tsp-core/datetime/utils";

import { InvoicesListingFilterValues } from "../types";

export const INVOICES_RECORDS_LISTING_DEFAULT_FILTER_VALUES: InvoicesListingFilterValues = {
  search: "",
  period: createDefaultSearchDatetimeRange(),
  limit: 50,
  page: 1,
};
